var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"globalbox"},[_c('div',{staticClass:"music"},[_c('audio',{ref:"media",staticClass:"audio",attrs:{"loop":"","width":"1","height":"1","preload":"none","src":_vm.ossurl}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683c74ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/musicPlay/musicPlay.vue
// module id = null
// module chunks = 